import axios from 'axios'
import { decode } from 'jsog'

const toData = response => decode(response.data)

export function getLocations(): Promise {
  return axios.get('/bw/location/').then(toData)
}

export function upsertLocation(data): Promise {
  return axios.post('/bw/location/', data).then(toData)
}

export function getLocationById(id): Promise {
  return axios.get(`/bw/location/${id}`).then(toData)
}

export function deleteLocation(id): Promise {
  return axios.delete(`bw/location/${id}`)
}





// WEBPACK FOOTER //
// ./src/services/location-service.js